import store from "@/stores";

const HIDDEN_KEY = "__canDirectiveHidden";

const apply = (el, binding) => {
  const allowed = store.getters["role/can"];
  if (!allowed(binding.value)) {
    if (el.style && !el[HIDDEN_KEY]) {
      el[HIDDEN_KEY] = true;
      el.style.setProperty("display", "none", "important");
    }
  } else if (el[HIDDEN_KEY]) {
    el[HIDDEN_KEY] = false;
    el.style.removeProperty("display");
  }
};

const can = {
  mounted: apply,
  updated: apply,
};

export default can;
